import { IRegularInfrastructureData } from '../../../types/map';

export function getInfrastructureByYear(
  geoObjectsMapByYear: Map<number, IRegularInfrastructureData>,
  year: number,
): IRegularInfrastructureData {
  return (
    geoObjectsMapByYear.get(year) || {
      geoObjectsData: [],
      futureTypes: [],
    }
  );
}
